var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_676_680",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1H1V24H24V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_676_680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.334 6.75C17.9632 6.75 19.209 7.99583 19.209 9.625V14.4167H21.1257V9.625C21.1257 7.325 19.4007 5.3125 17.1965 4.92917C16.8132 2.725 14.8007 1 12.5007 1H1.95898V24H15.3757V22.0833H3.87564V2.91667H12.5007C14.1298 2.91667 15.3757 4.1625 15.3757 5.79167V6.75H16.334ZM6.75064 7.70833V9.625H10.584V7.70833H6.75064ZM21.1257 19.2083V16.3333H19.209V19.2083H16.334V21.125H19.209V24H21.1257V21.125H24.0007V19.2083H21.1257ZM6.75064 13.4583H15.3757V11.5417H6.75064V13.4583Z",
    fill: "#8FABB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCreated);
export default __webpack_public_path__ + "static/media/New Created.3f2ffc3f0fc6725f53f297829c47fe41.svg";
export { ForwardRef as ReactComponent };